import {
    getSubscription,
    listSubscriptions
} from './queries';
import {
    createSubscription,
    deleteSubscription,
    updateSubscription,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateSubscription,
    DeleteSubscription,
    GetSubscription,
    ListSubscriptions,
    Subscription,
    UpdateSubscription
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();


export const fetchRecords = async (filter?: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListSubscriptions>>({
                                                                               query: listSubscriptions,
                                                                               variables: {...(filter ? {filter} : {}), limit, nextToken},
                                                                           });
    return response.data?.listSubscriptions;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetSubscription>>({
                                                                             query: getSubscription,
                                                                             variables: {id: id},
                                                                         });
    return response.data?.getSubscription;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateSubscription>>({
                                                                                query: createSubscription,
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.createSubscription;
};

export const update = async (_id: string, record: Subscription) => {
    const payload = {...record} as Record<string, unknown>;
    delete payload.created;
    delete payload.updated;

    const response = await client.graphql<GraphQLQuery<UpdateSubscription>>({
                                                                                query: (updateSubscription),
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.updateSubscription;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteSubscription>>({
                                                                                query: (deleteSubscription),
                                                                                variables: {input: {id: id}},
                                                                            });
    return response.data?.deleteSubscription;
};
